import { Link } from 'react-router-dom'

import { TABS, listPath } from './paths.js'

// The Hoops tab bar: Tonight, Players, Leaders, Standings, Teams. P6-329c (GN-2c).
//
// ═══════════════════════════════════════════════════════════════════════════
// THE VIEW SAYS WHICH TAB IT IS; THE TAB BAR NEVER READS THE ADDRESS
// ═══════════════════════════════════════════════════════════════════════════
//
// `current` is passed in by the screen that draws the bar. Working it out from the pathname would be a second
// implementation of what the router has already decided (CLAUDE.md gotcha 21: a guard and a consumer are two
// implementations of one contract, and the way they disagree is spellings: `/HOOPS/Players`, `/hoops/%70layers`), so
// the bar trusts the screen, and the screen was chosen by the router.
//
// A player's page is under the Players tab and a team's under Teams, whichever list it was opened from: the tab is
// the family, and the Back button (`useBack.js`) is what remembers where this visit came from.
//
// TONIGHT IS A BUTTON WHERE IT IS ALREADY THE SCREEN. In the portal's Hoops pill and on `/hoops/tonight` the Tonight
// tab is the page you are on, so tapping it closes a game that is open (a history entry, as GN-1b built it) and does
// nothing otherwise. Everywhere else it is a link to `/hoops/tonight`. The four others are always links, so a long-press
// or a middle click opens them in a new tab, which is the point of their being paths.
//
// THE SEASON TRAVELS WITH THE TAB. The design's prototype holds one season for every view ("every view shows the
// same two segments"), so a member who has been reading 2024-25 and taps Standings expects 2024-25. With real paths the
// season is in the address, so the four season tabs carry it (`season`, which a season view passes as the address's own
// when it names a published season) and Tonight, which has no season, never does.
//
// The wrap is the stylesheet's: five tabs at 44px do not fit one row below about 420px, and the bar wraps to two rows
// instead of scrolling sideways (HANDOFF-seasons.md, flag 11). The "Hoops" label is drawn from 768px up.

export default function HoopsTabs({ current, tonightIsHere = false, onTonight, season = null }) {
  return (
    <nav className="d2d-hoops__nav" aria-label="Hoops">
      <span className="d2d-hoops__navlabel d2d-micro">Hoops</span>
      {TABS.map((tab) => {
        const here = tab.key === current
        if (tab.key === 'tonight' && tonightIsHere) {
          return (
            <button
              type="button"
              key={tab.key}
              className="d2d-hoops__tab"
              aria-current={here ? 'page' : undefined}
              data-testid={`hoops-tab-${tab.key}`}
              onClick={onTonight}
            >
              {tab.label}
            </button>
          )
        }
        return (
          <Link
            key={tab.key}
            to={tab.key === 'tonight' ? tab.path : listPath(tab.key, season)}
            className="d2d-hoops__tab"
            aria-current={here ? 'page' : undefined}
            data-testid={`hoops-tab-${tab.key}`}
          >
            {tab.label}
          </Link>
        )
      })}
    </nav>
  )
}
